import { httpClient } from '@/services/http/httpClient'

export type ChangePermissionUserProject = {
  projectId: string
  userId: string
  permission: string
}

export const changePermissionUserProject = async ({
  projectId,
  userId,
  permission,
}: ChangePermissionUserProject) => {
  await httpClient.put(`/projects/portfolio-projects/${projectId}/permission`, {
    permission,
    userId,
  })
}
